import { call, put } from "redux-saga/effects";
import { arrayToEntityMap } from "lib/data";
import { sendSchoolMoneyDataRequest } from "state/fetchSagas";
import { getSchoolMoneyLocalStoreData, saveSchoolMoneyLocalStoreData } from "state/localStore";
import { fetchParentsSucceeded } from "state/school_money/actions";

import Parent from "state/school_money/entities/Parent";

export default function* fetchParentsSaga(action) {
  const forceApiRefresh = action.payload.forceApiRefresh;

  let parentsData;
  if(!forceApiRefresh) {
    parentsData = getSchoolMoneyLocalStoreData("parent");
  }

  if(parentsData === undefined) {
    const response = yield call(sendSchoolMoneyDataRequest, "get_parents");
    parentsData = response.data.parents;
    saveSchoolMoneyLocalStoreData("parent", parentsData);
  }

  const parentsByID = arrayToEntityMap(Parent.fromAppserver, parent => parent.id, parentsData);

  yield put(fetchParentsSucceeded(parentsByID));

}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/fetchParentsSaga.js